import get from 'lodash/get'

import type { Theme } from '~/common/theme'

type ThemeProps = {
  theme: Theme
}

export const themeKey =
  (path: string) =>
  ({ theme }: ThemeProps): string =>
    get(theme, path)
